
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {CommonMasterApi } from '../api/commonmaster.api';
import {  CommonMasterData } from '../../../interfaces/masters/commonmaster'

@Injectable()
export class CommonMasterService extends CommonMasterData {

  constructor(private api: CommonMasterApi) {
    super();
  }
  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }
  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }

}
